import { DataGrid } from "devextreme-react";
import React from "react";
import { getPropsDataGrid } from "../../utils/default-props";
import { Column, Toolbar } from "devextreme-react/cjs/data-grid";
import { getDataGridCustomToolbarCaption } from "../../components/default-components/data-grid-custom-toolbar";
import LoaderPage from "../../layouts/loader-page/loader-page";

export function ApprovalRequestList() {

    return (
        <React.Fragment>
            <LoaderPage loading={false}>
                <DataGrid
                    dataSource={undefined}
                    {...getPropsDataGrid}
                >
                    <Toolbar>
                        {getDataGridCustomToolbarCaption("Onay Bildirimleri")}

                    </Toolbar>
                    <Column dataField="a1" caption="ID" />
                    <Column dataField="talepEden" caption="Talep Eden" />
                    <Column dataField="talepTuru" caption="Telep Türü" />
                    <Column dataField="talepTarihi"
                        caption="TalepTarihi"
                        editorType="dxDateBox"
                        //editorOptions={dateEditorOption}
                        dataType="datetime"
                        format="shortDate"
                    />
                    <Column dataField="onayDurumu" caption="Onay Durumu" />
                </DataGrid>
            </LoaderPage>

        </React.Fragment>
    )
}